import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

const EntityPickerModalLoadMoreError = ({ onTryAgain }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          height: 68,
          paddingLeft: 50,
        },
      ]}
    >
      <AlertWarningIcon
        style={{
          color: theme.colors.charcoal700,
        }}
      />
      <span
        css={[
          theme.typography.bodySmall,
          {
            marginLeft: 12,
            marginRight: 8,
            color: theme.colors.charcoal700,
          },
        ]}
      >
        {T.translate('ERROR_LOADING_RESULTS')}
      </span>
      <LinkButton onClick={onTryAgain} style={theme.typography.bodySmall}>
        {T.translate('TRY_AGAIN')}
      </LinkButton>
    </div>
  );
};

EntityPickerModalLoadMoreError.propTypes = {
  /** Handler for try again click */
  onTryAgain: PropTypes.func.isRequired,
};

export default EntityPickerModalLoadMoreError;
